import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterAutobedrijfPage() {
  return <ClusterPageTemplate clusterName="Autobedrijf" sectorName="Lokale Retail & Dienstverlening" sectorSlug="lokale-retail" heroTitle="Website laten maken voor een autobedrijf" heroDescription="Een premium, snelle website voor jouw autodealer of occasioncenter. Wij bouwen websites die jouw voorraad perfect presenteren en leads genereren." websiteOnderdelen={[{
    icon: 'CarIcon',
    title: 'Occasion aanbod',
    description: 'Een razendsnelle, visueel aantrekkelijke presentatie van je voorraad met uitgebreide zoekfilters.'
  }, {
    icon: 'FileTextIcon',
    title: 'Inruilmodule',
    description: 'Een formulier waarmee klanten direct de inruilwaarde van hun huidige auto kunnen aanvragen.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Proefrit aanvragen',
    description: 'Geïntegreerde knoppen bij elke auto om laagdrempelig een bezichtiging of proefrit te plannen.'
  }, {
    icon: 'WrenchIcon',
    title: 'Werkplaats & Service',
    description: 'Informatie over garantie (BOVAG), afleverpakketten, financiering en onderhoud.'
  }]} functionaliteiten={[{
    icon: 'LaptopIcon',
    title: 'Voorraad koppeling',
    description: 'Automatische synchronisatie met VWE, Wheelerdelta, Autodata of andere occasion-beheersystemen.'
  }, {
    icon: 'SearchIcon',
    title: 'Geavanceerde filters',
    description: 'Laat bezoekers zoeken op merk, model, bouwjaar, kilometerstand, brandstof en prijs.'
  }, {
    icon: 'CameraIcon',
    title: 'Fotogalerijen',
    description: "Geoptimaliseerde weergave van tientallen hoge resolutie foto's per auto, zonder snelheidsverlies."
  }]} siblingClusters={[{
    name: 'Kapsalon',
    slug: 'kapsalon'
  }, {
    name: 'Fietsenwinkel',
    slug: 'fietsenwinkel'
  }, {
    name: 'Garage',
    slug: 'garage'
  }]} faqs={[{
    q: 'Koppelen jullie met Wheelerdelta of VWE?',
    a: "Ja, wij bouwen naadloze koppelingen via API's of iFrames met alle bekende occasion-beheersystemen in Nederland."
  }, {
    q: 'Hoe zorg ik voor meer proefrit-aanvragen?',
    a: 'We plaatsen opvallende call-to-actions bij elke auto en maken het formulier zo kort en makkelijk mogelijk, speciaal geoptimaliseerd voor mobiel.'
  }, {
    q: 'Wat kost een website voor een autodealer?',
    a: 'Een website inclusief een geavanceerde, automatische occasion-koppeling en zoekfilters is maatwerk. Prijzen starten doorgaans rond de €2.500.'
  }, {
    q: 'Is de voorraad goed te bekijken op een mobiele telefoon?',
    a: 'Absoluut. Het grootste deel van de autokopers zoekt via mobiel. Onze occasion-overzichten en fotogalerijen zijn 100% mobile-first ontworpen.'
  }]} data-id="element-1073" />;
}